import orderBy from 'lodash/orderBy';
import EcsInteraction from '@/components/ecs-interaction/EcsInteraction';

// Pending Interactions

const getPendingInteractions = state => Array.from(state.interactions.pending, i => new EcsInteraction(i));

const getPendingTelephonyInteractions = state => {
  return Array.from(state.interactions.pending, i => new EcsInteraction(i)).filter(j => j.isTelephony);
};

const getPendingChatInteractions = state => {
  return Array.from(state.interactions.pending, i => new EcsInteraction(i)).filter(j => j.isChat);
};

const getPendingEmailInteractions = state => {
  return Array.from(state.interactions.pending, i => new EcsInteraction(i)).filter(j => j.isEmail);
};

const getPendingSmsInteractions = state => {
  return Array.from(state.interactions.pending, i => new EcsInteraction(i)).filter(j => j.isSms);
};

const getPendingInteraction = state => interactionId => {
  const interaction = state.interactions.pending.find(interaction => interaction.interactionId === interactionId);
  return interaction ? new EcsInteraction(interaction) : null;
};

// Active Interactions

const getActiveInteractions = state => Array.from(state.interactions.active, i => new EcsInteraction(i));

const getActiveInteraction = state => interactionId => {
  const interaction = state.interactions.active.find(interaction => interaction.interactionId === interactionId);
  return interaction ? new EcsInteraction(interaction) : null;
};

const getActiveTelephonyInteractions = state => {
  return Array.from(state.interactions.active, i => new EcsInteraction(i)).filter(j => j.isTelephony);
};

const getActiveChatInteractions = state => {
  return Array.from(state.interactions.active, i => new EcsInteraction(i)).filter(j => j.isChat);
};

const getActiveEmailInteractions = state => {
  return Array.from(state.interactions.active, i => new EcsInteraction(i)).filter(j => j.isEmail);
};

const getActiveSmsInteractions = state => {
  return Array.from(state.interactions.active, i => new EcsInteraction(i)).filter(j => j.isSms);
};

// Historical Interactions

const getInteraction = state => interactionId => {
  const interaction = [...state.interactions.active, ...state.interactions.history].find(
    i => i.interactionId === interactionId
  );
  return interaction ? new EcsInteraction(interaction) : null;
};

const getHistoricalChatInteractions = state => {
  return structuredClone(state.interactions.history)
    .map(interaction => new EcsInteraction(interaction))
    .filter(interaction => !interaction.isInternalChat)
    .filter(interaction => interaction.isChat);
};

const getHistoricalTelephonyInteractions = state => {
  return structuredClone(state.interactions.history)
    .map(interaction => new EcsInteraction(interaction))
    .filter(interaction => interaction.isTelephony);
};

const getHistoricalEmailInteractions = state => {
  return structuredClone(state.interactions.history)
    .map(interaction => new EcsInteraction(interaction))
    .filter(interaction => interaction.isEmail);
};

const getHistoricalSmsInteractions = state => {
  return structuredClone(state.interactions.history)
    .map(interaction => new EcsInteraction(interaction))
    .filter(interaction => interaction.isSms);
};

const getHistoricalInteraction = state => interactionId => {
  return structuredClone(state.interactions.history)
    .map(interaction => new EcsInteraction(interaction))
    .find(interaction => interaction.interactionId === interactionId);
};

const historicalInteractionsSince = state => {
  return state.historySince;
};

const getCrmContactsForInteractions = (state, getters, rootState, rootGetters) => {
  const interactions = [...state.interactions.active, ...state.interactions.history].filter(
    interaction => interaction.crm.contactId
  );
  const contacts = [...new Set(interactions.map(({ crm: { contactId } }) => contactId))]
    .map(contactId => rootGetters['CONTACTS/getCrmContact'](contactId))
    .filter(contact => (contact ? !!contact.name : false));
  return orderBy(contacts, [o => o.isFavorite, o => new Date(o.modifiedTime)], ['desc', 'desc']);
};

export default {
  getPendingInteractions,
  getPendingInteraction,
  getPendingTelephonyInteractions,
  getPendingChatInteractions,
  getPendingEmailInteractions,
  getActiveInteractions,
  getActiveInteraction,
  getActiveTelephonyInteractions,
  getActiveChatInteractions,
  getActiveEmailInteractions,
  getActiveSmsInteractions,
  getHistoricalInteraction,
  getHistoricalTelephonyInteractions,
  getHistoricalChatInteractions,
  getHistoricalEmailInteractions,
  getHistoricalSmsInteractions,
  getInteraction,
  getPendingSmsInteractions,
  getCrmContactsForInteractions,
  historicalInteractionsSince
};
